import { useQuery } from '@tanstack/react-query'
import { fetchService } from '../api'

export function useServiceData(slug) {
  return useQuery({
    queryKey: ['service', slug],
    queryFn: () => fetchService(slug),
    enabled: !!slug,
    staleTime: 30_000,
  })
}
